import { Controller } from 'stimulus';

import $ from 'jquery';

require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");

import Select2 from "select2";
export default class extends Controller {
  static targets = ['study', 'siteSelect', 'siteSelectAll'];

    connect() {
        $('.site-search').select2();
        // $('.study-search').select2();
    }
    photographerStudyData() {
    this.selectChangeUrl= document.location.origin + `/ocap_photographers_get_study_sites.json`;
    const study_id = this.studyTarget.value;
    fetch(this.selectChangeUrl, {
      headers: {
          'Content-Type': 'application/json; charset=utf-8',
          'X-CSRF-Token': document.head.querySelector('meta[name="csrf-token"]').getAttribute('content')
      },
      body: JSON.stringify({ study_id: study_id }),
      method: 'POST',
    })
    .then(response => response.json())
      .then((data) => {
          const selectBox = this.siteSelectTarget;
          selectBox.disabled = false;
          selectBox.innerHTML = '';
          // default text
          const defaultOption = document.createElement('option');
          defaultOption.value = "";
          defaultOption.innerHTML = "Select Sites";
          defaultOption.selected === "";
          selectBox.appendChild(defaultOption);
          
          
          data["sites"].forEach((site) => {
            const opt = document.createElement('option');
            opt.value = site.id;
            opt.innerHTML = `${site.name} (${site.code})`;
            selectBox.appendChild(opt);
          });

      });
    }
    selectAllChange(event, role = false, roleOption) {

        const selected = role ? roleOption : document.getElementsByClassName("checkbox_select_all")[0].checked;

        $('.site-search').select2("destroy");
        $('.site-search').find('option').attr('selected', selected);
        $('.site-search').select2();

        // check select all else deselect
        if ($(".site-search :selected").length == $('.site-search option').length) {
            document.getElementsByClassName("checkbox_select_all")[0].checked = true;
        } else {
            document.getElementsByClassName("checkbox_select_all")[0].checked = false;
        }
    }

}